// extracted by mini-css-extract-plugin
export default {"wrapper":"AdminSettings_wrapper__OFH7M","container":"AdminSettings_container__ER1ZA"};